import { ROOT_URL } from '../utils/constants';
import { getAuthHeader } from '.';
import type { LoginViewModel } from '../models/AccountViewModels/LoginViewModel';
import type { RegisterViewModel } from '../models/AccountViewModels/RegisterViewModel';
import type { ForgotPasswordViewModel } from '../models/AccountViewModels/ForgotPasswordViewModel';
import type { ResetPasswordViewModel } from '../models/AccountViewModels/ResetPasswordViewModel';
import type { UpdateUser } from '../models/AccountViewModels/UpdateUser';
import type { DeleteUserViewModel } from '../models/AccountViewModels/DeleteUserViewModel';
import type { GetUser } from '../models/GetUser';

class AuthApi {
  static async login(
    values: LoginViewModel,
  ): Promise<{ token: string } | { [key: string]: string[] }> {
    const response = await fetch(`${ROOT_URL}/api/account/Login`, {
      method: 'POST',
      credentials: 'include',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(values),
    });
    return await response.json();
  }

  static async register(values: RegisterViewModel) {
    const response = await fetch(`${ROOT_URL}/api/account/register`, {
      method: 'POST',
      credentials: 'include',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(values),
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }

  static async getUser(): Promise<GetUser> {
    const [headers] = await getAuthHeader();
    const response = await fetch(`${ROOT_URL}/api/account/getuser`, {
      method: 'GET',
      credentials: 'include',
      headers: headers,
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }

  static async getUserSubscriptions(): Promise<{ isAdFree: boolean }> {
    const [headers] = await getAuthHeader();
    const response = await fetch(
      `${ROOT_URL}/api/account/getusersubscriptions`,
      {
        method: 'GET',
        credentials: 'include',
        headers: headers,
      },
    );
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }

  static async logout() {
    const [headers] = await getAuthHeader();
    await fetch(`${ROOT_URL}/api/account/logout`, {
      method: 'POST',
      credentials: 'include',
      headers: headers,
      body: JSON.stringify({}),
    });

    return null;
  }

  static async forgotPassword(values: ForgotPasswordViewModel) {
    const response = await fetch(`${ROOT_URL}/api/account/forgotpassword`, {
      method: 'POST',
      credentials: 'include',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(values),
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
  static async resetPassword(values: ResetPasswordViewModel) {
    const response = await fetch(`${ROOT_URL}/api/account/resetpassword`, {
      method: 'POST',
      credentials: 'include',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(values),
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }

  static async updateUserNames(values: UpdateUser) {
    const [headers] = await getAuthHeader();
    const response = await fetch(`${ROOT_URL}/api/account/updateuser`, {
      method: 'PUT',
      credentials: 'include',
      headers: headers,
      body: JSON.stringify(values),
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
  static async deleteUser(values: DeleteUserViewModel) {
    const [headers] = await getAuthHeader();
    const response = await fetch(`${ROOT_URL}/api/account/deleteuser`, {
      method: 'POST',
      credentials: 'include',
      headers: headers,
      body: JSON.stringify(values),
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }

  static async downloadData() {
    const [headers] = await getAuthHeader();
    const response = await fetch(`${ROOT_URL}/api/account/export`, {
      method: 'GET',
      credentials: 'include',
      headers: headers,
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response;
  }
}

export default AuthApi;
